"use strict";

/**
 * @module ValueStream
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueStreamImpl = void 0;
var stream_1 = require("./../../events/stream");
/**
 * Implementation of a value stream
 */
var ValueStreamImpl = /** @class */function (_super) {
  __extends(ValueStreamImpl, _super);
  /**
   * Create a new ValueStreamImpl instance
   *
   * @param emitterFactory  an emitter factory. Events are emitted on the stream
   *                        by the {@link ValueStreamProxy}
   * @param selector        the topic selector
   */
  function ValueStreamImpl(emitterFactory, selector) {
    var _this = _super.call(this, emitterFactory) || this;
    _this.selector = selector;
    return _this;
  }
  return ValueStreamImpl;
}(stream_1.StreamImpl);
exports.ValueStreamImpl = ValueStreamImpl;